import { parseLocaleNumber } from "./decimal";

function toNumber(value) {
  const number = parseLocaleNumber(value);
  return Number.isFinite(number) ? number : 0;
}

function average(values) {
  if (!values.length) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
}

export function buildTaskCostMap(tasks = []) {
  const completedCostsByTitle = {};

  for (const task of tasks) {
    if (task.is_template || !task.completed || task.task_cost == null) continue;
    const cost = toNumber(task.task_cost);
    if (cost <= 0) continue;
    if (!completedCostsByTitle[task.title]) completedCostsByTitle[task.title] = [];
    completedCostsByTitle[task.title].push(cost);
  }

  const map = {};
  for (const task of tasks) {
    if (!task.is_template) continue;

    const trackedCost = average(completedCostsByTitle[task.title] || []);
    const estimatedMinutes = toNumber(task.estimated_minutes);
    const estimatedRate = toNumber(task.estimated_hourly_rate);
    const estimatedCost = estimatedMinutes > 0 && estimatedRate > 0
      ? (estimatedMinutes / 60) * estimatedRate
      : 0;

    map[task.id] = task.labor_cost_mode === "tracked" && trackedCost > 0
      ? trackedCost
      : estimatedCost;
  }

  return map;
}

export function calculateAllocatedTaskLaborCost(taskAllocations = [], taskCostMap = {}) {
  return taskAllocations.reduce((sum, allocation) => {
    const taskCost = toNumber(taskCostMap[allocation.task_id]);
    const percentage = toNumber(allocation.percentage);
    return sum + taskCost * (percentage / 100);
  }, 0);
}
